const push = (array, ...values) => {
  array.push(...values)
  return array
}

module.exports = push
